import { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';

import classes from './AddNewEmail.module.css';

const AddNewEmail = props => {
  const [newEmail, setNewEmail] = useState('');
  const [enableAddBtn, setEnableAddBtn] = useState(false);

  const addNewEmailHandler = () => {
    props.addNewEmail(newEmail, 1, 'INSERT');
    props.close();
    setNewEmail('');
  };

  const closeHandler = () => {
    props.close();
    setNewEmail('');
  };

  const changeInputHandler = event => {
    setNewEmail(event.target.value);
    setEnableAddBtn(validateEmail(event.target.value));
  };

  const validateEmail = email => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  return (
    <Dialog
      onClose={closeHandler}
      open={props.open}
      fullWidth
      maxWidth="xs"
      className={classes.newEmailcontainer}
    >
      <p className={classes.title}>
        Agregar correo electrónico alternativo
      </p>
      <TextField
        label="Correo electrónico alternativo"
        className={classes.textField}
        placeholder="Correo electrónico alternativo"
        value={newEmail}
        variant="outlined"
        onChange={changeInputHandler}
        size="small"
      />
      <div className={classes.btnsContainer}>
        <Button
          className={classes.cancelEmailBtn}
          onClick={closeHandler}
        >
          Cancelar
        </Button>
        <Button
          className={classes.addEmailBtn}
          onClick={addNewEmailHandler}
          disabled={!enableAddBtn}
        >
          Agergar
        </Button>
      </div>
    </Dialog>
  );
};

AddNewEmail.propTypes = {
  // eslint-disable-next-line react/require-default-props
  close: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  open: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  addNewEmail: PropTypes.func
};

export default AddNewEmail;
